/**
 * B_Resource.js
 *
 * @경로 : /public/scripts/game/lcPlugIn/canvas/base/dev/model/B_Resource.js
 * @목적 : 'Preload' 될때 사용자가 요청한 값들이 수정될 수 없게 'resource를 wrapping 처리함'
 * @진행 : 개발종료
 * @주의 : 사용자가 요청한 리소스를 참조할때 보는 객체인데 단순 보는 목적이기 때문에 값을 수정할 수 없음
 * @이슈 : 'result' 값이 최초에는 수정할수 있으나 한번 값이 할당되면 수정할 수 없어야함
 * @일자 : 2018.mm.dd
 * @작성 : SuperMoon
 * @참조 :
 */

const B_Resource = (function(){

	return class {
		constructor(obj) {
			try {

				if (typeof obj === 'object') {
					Object.keys(obj).forEach(key => {

						Object.defineProperty(this, key, {
							value: obj[key],
							writable: false,
							configurable: false,
							enumerable: true
						});
					});
				}

				// [#] B_Real에서 추가
				// this._count = 0;

			} catch (e) { console.log('B_Resource', e); }
		}

		// [V] public

		// @DES :: count {num} - 갯수
		get count() { return this._count; }
		set count(c) { this._count = c; }

		// @DES :: result {obj} - 결과값 (최초수정만 허함)
		get result() { return this._result; }
		set result(r) { if(typeof this._result === 'undefined') this._result = r; }

	}
}());

export default B_Resource;


// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/base/dev/model/B_Resource.js